import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, switchMap, throwError } from 'rxjs';
import { OauthService } from '../../pages/login/data-access/services/oauth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const oauthService = inject(OauthService);
  const token = oauthService.getToken();
  
  if (!token) {
    return next(req);
  }
  
  const authReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${token}`)
  });
  
  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.url.includes('/auth/refresh')) {
        return oauthService.refreshToken().pipe(
          switchMap((response) => {
            const newAuthReq = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${response.access_token}`)
            });
            return next(newAuthReq);
          }),
          catchError((refreshError) => {
            oauthService.clearToken();
            router.navigate(['/login']);
            return throwError(() => refreshError);
          })
        );
      }
      
      return throwError(() => error);
    })
  );
};
